import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '@cr-environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  imports: [TranslateModule],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  protected readonly environment = environment;
}
